module.exports = __webpack_public_path__ + "media/images/no-billing-history-81469e1c280d9d530e6d75e95f84f60f.svg";